import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'audioBitDepth';

export class AudioBitDepth extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
